// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Composer */
.message-composer {
  display: flex;
}

.message-composer:focus {
  outline: none;
}

.message-composer textarea,
.message-composer textarea:focus {
  resize: none;
  border-radius: 0.28571429rem 0 0 0.28571429rem;
  margin-left: 1px;
}

.message-composer .button {
  border-radius: 0 0.28571429rem 0.28571429rem 0;
  width: 45px;
  margin: 0px;
}

.message-composer.large .actions.button .caption {
  display: flex !important;
  align-items: center !important;
  opacity: 0.9;
}

.message-composer > .input {
  width: 100%;
}

#normal-layout .message-composer > .input {
  /* Leave some empty space to the right for better styling with ugly native scrollbars (especially with Firefox) */
  width: calc(100% - 60px);
}
`, "",{"version":3,"sources":["webpack://./src/routes/Sidebar/components/chat/message-composer.css"],"names":[],"mappings":";AACA,aAAa;AACb;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iHAAiH;EACjH,wBAAwB;AAC1B","sourcesContent":["\r\n/* Composer */\r\n.message-composer {\r\n  display: flex;\r\n}\r\n\r\n.message-composer:focus {\r\n  outline: none;\r\n}\r\n\r\n.message-composer textarea,\r\n.message-composer textarea:focus {\r\n  resize: none;\r\n  border-radius: 0.28571429rem 0 0 0.28571429rem;\r\n  margin-left: 1px;\r\n}\r\n\r\n.message-composer .button {\r\n  border-radius: 0 0.28571429rem 0.28571429rem 0;\r\n  width: 45px;\r\n  margin: 0px;\r\n}\r\n\r\n.message-composer.large .actions.button .caption {\r\n  display: flex !important;\r\n  align-items: center !important;\r\n  opacity: 0.9;\r\n}\r\n\r\n.message-composer > .input {\r\n  width: 100%;\r\n}\r\n\r\n#normal-layout .message-composer > .input {\r\n  /* Leave some empty space to the right for better styling with ugly native scrollbars (especially with Firefox) */\r\n  width: calc(100% - 60px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
